import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-icon-awaiting-training',
    templateUrl: './awaiting-training.component.svg',
    styleUrls: ['./awaiting-training.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AwaitingTrainingComponent {}
